import React, { useState, useRef } from "react";
import classNames from "classnames";

import { useI18n } from "Hooks";
import classes from "./AddMembersSearch.scss";

import { isMessagingRevempEnabled } from "MessagingV2/modules/Utils";
import UsersPopover from "MessagingV2/components/ThreadList/CreateNewChatModal/components/UsersPopover";
import SearchInput from "MessagingV2/components/ThreadList/CreateNewChatModal/components/SearchInput";

const getSearchLabel = ({ channelLabel, isManageMember, t }) => {
  if (isManageMember) {
    return t("common:search_and_label", {
      label: t("common:add_members_to", { label: `#${channelLabel}` }),
    });
  }
  return t("common:add_members_to", { label: `#${channelLabel}` });
};

const overrideClasses = {
  searchContainer: classes.searchContainer,
};

const AddMembersSearch = props => {
  const {
    handleAddUser,
    excludedUserIds,
    channelLabel,
    overlayContainerStyle,
    isManageMember,
    includePaidUsersOnly = false,
  } = props;
  const { t } = useI18n(["common"]);
  const isUIRevempEnabled = isMessagingRevempEnabled();

  const [searchText, setSearchText] = useState("");
  const containerRef = useRef(null);

  const onUserClick = user => {
    setSearchText(""); // clear the search text after adding user
    handleAddUser({ user });
  };

  const searchLabelClasses = classNames(classes.searchLabel, "text-label-2");

  return (
    <div>
      {channelLabel && !isUIRevempEnabled ? (
        <div className={searchLabelClasses}>
          {getSearchLabel({ channelLabel, isManageMember, t })}
        </div>
      ) : null}
      <SearchInput
        overrideClasses={overrideClasses}
        updateSearchText={setSearchText}
        searchText={searchText}
        placeholder={t("common:search_for_all_user_types")}
      />
      <div className={classes.usersPopoverContainer} ref={containerRef}>
        <UsersPopover
          containerRef={containerRef}
          searchText={searchText}
          onUserClick={onUserClick}
          excludedUserIds={excludedUserIds}
          overlayContainerStyle={overlayContainerStyle}
          includePaidUsersOnly={includePaidUsersOnly}
          isPopOver={true}
        />
      </div>
    </div>
  );
};

export default AddMembersSearch;
